// This file defines Amplitude feature flags used in the application.
export const FEATURES = {
  CampaignBenchmarks: 'wmg_frontend_campaign_benchmarks',
} as const;
